import {resources} from "../../../../../../../core/models/resource/resources";

export const priceLevelConfigCopyModalName: string = 'price-level-config-copy';
export const priceLevelConfigCopyResourceType = resources['price-level-configs'];
